var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArchiveManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17924_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1173 6.48389C14.5074 7.12795 14.8747 7.73442 15.1325 8.1602C15.2693 8.38598 15.3376 8.49888 15.386 8.61956C15.4289 8.72671 15.4601 8.83821 15.4789 8.9521C15.5 9.08039 15.5 9.21242 15.5 9.47647V12.9881C15.5 13.8776 15.5 14.3224 15.3269 14.6621C15.1746 14.9609 14.9317 15.2039 14.6328 15.3562C14.2931 15.5293 13.8483 15.5293 12.9588 15.5293H3.04118C2.15168 15.5293 1.70693 15.5293 1.36719 15.3562C1.06835 15.2039 0.825377 14.9609 0.673107 14.6621C0.5 14.3224 0.5 13.8776 0.5 12.9881V9.49706C0.5 9.22556 0.5 9.08981 0.521638 8.96007C0.54115 8.84307 0.572005 8.73389 0.616618 8.62398C0.666089 8.50211 0.738919 8.38355 0.88458 8.14642C1.2159 7.60705 1.56853 7.02248 1.89079 6.48389",
    stroke: "#0D0D0D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.2051H13.1424C12.5743 10.2051 12.2902 10.2051 12.0684 10.3524C11.8466 10.4997 11.7364 10.7615 11.5159 11.2851L11.4341 11.4794C11.2137 12.003 11.1035 12.2648 10.8817 12.4121C10.6599 12.5594 10.3758 12.5594 9.80768 12.5594H6.04213C5.46359 12.5594 5.17431 12.5594 4.95182 12.4108C4.93331 12.3985 4.91528 12.3854 4.89775 12.3717C4.68713 12.2067 4.59683 11.9319 4.41622 11.3823C4.23562 10.8326 4.14531 10.5578 3.93469 10.3928C3.91717 10.3791 3.89913 10.366 3.88063 10.3537C3.65813 10.2051 3.36886 10.2051 2.79031 10.2051H0.5",
    stroke: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.778 1.423C7.14983 0.221717 8.85017 0.221717 9.222 1.423V1.423C9.41965 2.06155 10.0756 2.44027 10.7274 2.29216V2.29216C11.9537 2.01353 12.8039 3.48608 11.9494 4.40873V4.40873C11.4953 4.89917 11.4953 5.65661 11.9494 6.14706V6.14706C12.8039 7.06971 11.9537 8.54225 10.7274 8.26363V8.26363C10.0756 8.11552 9.41965 8.49424 9.222 9.13279V9.13279C8.85017 10.3341 7.14983 10.3341 6.778 9.13279V9.13279C6.58035 8.49424 5.92439 8.11552 5.27256 8.26363V8.26363C4.04631 8.54225 3.19614 7.06971 4.05056 6.14706V6.14706C4.50474 5.65661 4.50474 4.89917 4.05056 4.40873V4.40873C3.19614 3.48608 4.04631 2.01353 5.27256 2.29216V2.29216C5.92439 2.44027 6.58035 2.06155 6.778 1.423V1.423Z",
    stroke: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.27777,
    r: 1.5,
    stroke: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17924_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArchiveManager);
export default __webpack_public_path__ + "static/media/icon-archive-manager.b2af0e77fd5adfc50b8c762bcc89a94c.svg";
export { ForwardRef as ReactComponent };